import axios from "axios";

const DOC_ENDPOINTS = {
    aadhar: "/api/v1/users/docs/aadhar-details",
    aadhaar: "/api/v1/users/docs/aadhar-details",
    pan: "/api/v1/users/docs/pan-details",
};

export const verifiedAadharQRDataHelperAPI = async (payload = {}) => {
    try {
        const token =
            typeof payload === "string"
                ? payload
                : payload?.token || localStorage.getItem("objectId");
        const docType =
            typeof payload === "string"
                ? "aadhar"
                : (payload?.docType || "aadhar").toLowerCase();
        const apiKey = process.env.REACT_APP_API_KEY;
        const endpoint = DOC_ENDPOINTS[docType] || DOC_ENDPOINTS.aadhar;

        if (!token) {
            throw new Error("Token is required to load the public document view");
        }

        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
            {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        }
        );

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};
